export default {
    nav: {
        index: "홈페이지",
        theme: "테마파크",
        restaurant: "음식음식음식",
        activity: "테마행사",
        performance: "멋진연역",
        service: "관광객서비스",
        online: "인터넷예약"
    },
    language: {
        Chinese: '중국어',
        English: '영문',
        korea: '한국어',
        Japanese: '일문'
    },
    service: {
        work_time: "영업 시간",
        traffic: "교통안내서",
        map_title: "단지지도",
        problems_title: "흔한 문제",
        notice_title: "여행객 안내",
        complaints_title: "불만 제기",
        video_title: "동영상 전용 코너",
        discount_title: "혜택 정보",
        tour_server: '가이드 서비스',
        security_check:'위조 방지 조회'
    },
    theme: [
        "장록스크림도",
        "동화동물왕국",
        "장록리조트",
        "군사테마파크",
        "농가악테마파크",
        "해저세계테마파크",
        "습지테마파크"],
    footerNav: [
        '인원모집',
        '뉴스센터',
        '연락',
        '장록에 대해',
        '회사 소개',
        '우정 링크',
        '나눔을 격려합니다'],
    theme_bg_tit: "테마 배경",
    cart: "쇼핑카트에 들어가다",
    name: "장록 여행 휴가박람원",//장녹관광휴박원
    search_title: "풀 텍스트 서치", //搜索页面标题
    service_tel: "고객 서비스 핫라인 ", //客服电话热线
    address: "주소", //地址
    address_content: "광동성 불산시  자오 산 저우 지안시 이스트로드 창루 관광 레저 엑스포 파크 ",
    activity: ['최근 활동', '특별 우대', '개표 행사'],
    base_info: '기본 정보',//基本信息
    traffic_type: [
        "자가운전 노선",
        "버스 노선",
        "경전철 노선",
        '공항 노선'
    ],
    resume: '개인 이력',
    shop_cart: "카트",//购物车名词
    traffic_system: "창루여행휴가박원교통조회시스템",
    map_download: "지도 다운로드",
    order: '주문정보 확인',
    pay_info: "지불 성공",
    upload: "연례 카드 정보 업로드",
    personal: "프라이비트 센터",
    card_bag: "내 카드 가방",
    login: "로그인",
    register: "등기",
    join: '저의 응모',
    my_order: "저의 주문서",
    tourist_map: "관광 안내도",
    work_type: [
        '사회 채용',
        '실습 채용',
        '인재후보자 모집채용',
        '아르바이트 채용'
    ],
    enter_key: "키 문자를 입력해 주십시오",// 招贤纳士的占位符
    time_notice: "더 많은 이벤트 공연에 대한 정보를 얻기 위해 상담 전화 번호를 사용할 수 있습니다.",
    consult_tel: "문의전화",
    online_type: [
        "티켓예약",
        "호텔예약",
        "장록 연 카드",
        "특혜판매촉진"
    ],
    placeholder_verity: "인증 번호를 입력하십시오",
    get_verity: "인증코드 가져오기",
    account: "계정 로그인",
    without_code: "비밀 로그인 해제",
    placeholder_code: "계좌번호를 입력하세요",
    placeholder_psd: "비밀번호 6-20을 입력하십시오",
    placeholder_img_verity: "그림 인증 코드를 입력하십시오",
    placeholder_repeat_psd: "비밀번호를 다시 입력하십시오",
    submit: "내다",
    send_code: "인증서 보내기",
    please_login: "로그인",
    experience: "작업 부서",
    department: "작업 부서",
    education: "학력 요구",
    recruitment: "채용 유형",
    recruitment_number: "모집 인원",
    release_time: "반포시기",
    work_address: "근무지",
    employ: "초빙하고 싶습니다",
    month: "달",
    newsNav: [
        "회사뉴스",
        "단지공고"
    ],
    view_count: "열람 건 수가",
    recent: "최근 소식",
    education_bg: "교육 배경",
    detail_address: "상세한 주소",
    save: "간수하다",
    submit_applications: "지원서를 내다",
    certificate: "증명서",
    tip: "다음 항목을 실행하기 전에 필기하고 저장하십시오",
    placeholder_c: "검색할 내용을 입력하십시오",
    contact_tel: "연락전화",
    switchboard: "대표전화",
    complaints_hotline: "신고전화",
    Medical_phone: "의료 전화",
    house_phone: "소방 전화",
    all_address: "광둥성 불산시 순더룬교삼주건설 동로장록 여행 휴가박람원(순더룬교 삼주과 판위사만 접경처)",
    company: "광동장녹관광휴박원유한회사",
    hotline: "문의전화",
    hotline_tip: "(24 문의 전화)",
    placeholder_location: "시작 위치를 입력하십시오",
    notice_tip: "이상은 반드시 관광객에게 준수를 요청해야 하며, 불편한 점은 경의로 생각하고 양해하시기바랍니다. 즐거운 여행 되십시오.",
    complaints_type: "고소 유형",
    select: "선택하십시오",
    phone: "휴대폰번호",
    placeholder_suggestion: "당신의 의견을 써 주십시오",
    sure_submit: "제출을 확인하다",
    activity_time: "활동 시간",
    still_time: "행사 종료 시간이 아직 남았습니다",
    start_time: "활동 시작 시간",
    grab_num: "이미 수량을 빼앗았다",
    all: "같은",
    piece: "넓은",
    select_time: "여행 날짜 선택",
    select_grab: "예매의 수량을 선택하십시오",
    activity_detail: "활동 정보",
    past: "끝나다",
    progress: "진행중",
    to: "에",
    show_time: "공연 시간",
    placeholder_key: "키워드에 따라 검색하기",
    job_title: "직위 이름",
    depart: "소속 부서",
    personal_data: "개인 정보",
    head_portrait: "얼굴을",
    compellation: "이름",
    sex: "성별",
    sex_men: "남자",
    sex_women: "여자",
    birthday: "생년월일",
    contact_way: "연락처 방식",
    email: "메일박스 주소",
    address_now: "현주소",
    height: "키",
    weight: "체중이",
    academic: "최고 학력",
    learning: "학습 형식",
    academic_lists:[
        "초등학교",
        "중학교",
        "중등 전문학교",
        "고등학교",
        "전문대",
        "본과",
        "대학원생",
        "박사"
    ],
    learning_lists:[
        "전일제 통일모집",
        "성인 대입 시험",
        "원격 교육",
        "검정고시",
        "국가개발대학"
    ],
    job_intention: "구직 의향",
    expected_salary: "월급을 기대하다",
    arrival_time: "출근 시간",
    next: "다음 단계",
    placeholder_name: "이름을 입력하십시오",
    placeholder_birth: "생년월일을 입력하십시오",
    placeholder_mail: "메일박스 주소를 입력하십시오",
    placeholder_way: "연락처를 입력하십시오",
    placeholder_address: "주소를 입력하십시오",
    placeholder_height: "키를 입력하십시오",
    placeholder_weight: "몸무게를 입력하십시오",
    placeholder_salary: "희망 세전 월봉을 입력하십시오",
    placeholder_arrival: "근무 시작 시간을 선택하십시오",
    upload_img: "이미지 업로드",
    upload_detail: "*부모와 어린이가 함께 찍은 상반신 사진을 올리다",
    idCard: "신원 번호",
    placeholder_real_name: "실명을 입력하십시오",
    placeholder_idCard: "신분증 번호를 기입해 주십시오",
    placeholder_phone: "핸드폰 번호를 적어 주세요",
    error_msg: "네트워크 오류, 관리자에게 연락하십시오.",
    discount: "할인권",
    date: "날짜",
    score: "점",
    total_score: "적분 총수",
    unused_score: "사용 가능한 포인트",
    used_score: "적분 사용",
    detail_info: "상세 정보",
    integration: "적분",
    order_num: "주문서 번호：",
    use_hour: "사용시간：",
    contact_person: "연락처 정보:",
    all_sum: "합치다:",
    personal_info: "인적 사항",
    certificate_card: "증명번호",
    age: "연세",
    mail: "우편함",
    submit_data: "개인 정보 보내기",
    placeholder_age: "나이를 입력하십시오",
    placeholder_card: "증명번호를 입력하십시오",
    placeholder_tel: "핸드폰 번호를 입력하십시오",
    join_grab : "기차표",
    crazy: "미치다",
    grabbing: "암표 도난 중" ,
    notYet: "아직",
    start: "시작",
    IC_case:'월(粤)상비',
    G_case :"월(粤)ICP비",
    home_axios: {
        main: [
            {
                "name": "입장권 예약",
                "mobile_value": "http://www.chuanloo.com/m/#/market?dex=0",
                "child": [
                    {
                        "name": "기동 놀이표",
                        "value": "http://www.chuanloo.com/web/tpl/onlineOrder/ticket-detail.html?goods_id=230",
                        "mobile_value": "http://www.chuanloo.com/m/#/ticketDetail?goods_id=230",
                    },
                    {

                        "name": "기동 관람권",
                        "value": "http://www.chuanloo.com/web/tpl/onlineOrder/ticket-detail.html?goods_id=166",
                        "mobile_value": "http://www.chuanloo.com/m/#/ticketDetail?goods_id=166",
                    },
                    {

                        "name": "동화동물원",
                        "value": "http://www.chuanloo.com/web/tpl/onlineOrder/ticket-detail.html?goods_id=167",
                        "mobile_value": "http://www.chuanloo.com/m/#/ticketDetail?goods_id=167",
                    },
                    {

                        "name": "해피 패밀리",
                        "value": "http://www.chuanloo.com/web/tpl/onlineOrder/ticket-detail.html?goods_id=190",
                        "mobile_value": "http://www.chuanloo.com/m/#/ticketDetail?goods_id=190",
                    }
                ]
            },
            {
                "name": "호텔 예약",
                "mobile_value": "http://www.chuanloo.com/m/#/market?dex=1",
                "child": [
                    {
                        "name": "특색 전원주택",
                        "mobile_value": "http://www.chuanloo.com/m/#/ticketDetail?goods_id=202",
                    },
                    {
                        "name": "특색 마차집",
                        "mobile_value": "http://www.chuanloo.com/m/#/ticketDetail?goods_id=195",
                    },
                    {

                        "name": "수이샹펑칭팡",
                        "mobile_value": "http://www.chuanloo.com/m/#/ticketDetail?goods_id=196",
                    },
                    {

                        "name": "복식 주택",
                        "value": "http://www.chuanloo.com/web/tpl/onlineOrder/hotelOrder.html",
                        "mobile_value": "http://www.chuanloo.com/m/#/ticketDetail?goods_id=198",
                    }
                ]
            },
            {
                "name": "장녹 년카",
                "mobile_value": "http://www.chuanloo.com/m/#/market?dex=2",
                "child": [
                    {
                        "name": "인용 연불카드",
                        "mobile_value": "http://#",
                    },
                    {
                        "name": "연인카드",
                        "mobile_value": "http://#",
                    },
                    {
                        "name": "패밀리 나이트 카드",
                        "mobile_value": "http://#",
                    },
                    {
                        "name": "친자년카드",
                        "mobile_value": "http://#",
                    }
                ]
            },
            {
                "name": "특혜 판촉",
                "mobile_value": "http://www.chuanloo.com/m/#/market/?dex=3",
                "child": [
                    {

                        "name": "따뜻한 패키지",
                        "mobile_value": "http://www.chuanloo.com/m/#/market/?dex=3",
                    },
                    {
                        "name": "하이샤셴음식점",
                        "mobile_value": "http://www.chuanloo.com/m/#/market/?dex=3",
                    },
                    {
                        "name": "팔각정 중식당",
                        "mobile_value": "http://www.chuanloo.com/m/#/market/?dex=3",
                    },
                    {
                        "name": "공룡곡 식당",
                        "mobile_value": "http://www.chuanloo.com/m/#/market/?dex=3",
                    }
                ]
            }
        ],
        minor: [
            {name: "영업 시간"},
            {name: "교통 안내"},
            {name: "공원지도"},
            {name: "제공 정보"}],
    },
}
